import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { BaseIcon } from '../../../components/base-icon.mjs';

const SvgSearch = forwardRef(
  (props, ref) => /* @__PURE__ */ jsxs(BaseIcon, { fill: "currentColor", ref, ...props, children: [
    /* @__PURE__ */ jsx("path", { d: "M10 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        d: "M21.707 21.707a1 1 0 0 1-1.414 0l-3.5-3.5a1 1 0 0 1 1.414-1.414l3.5 3.5a1 1 0 0 1 0 1.414",
        clipRule: "evenodd"
      }
    )
  ] })
);

export { SvgSearch as default };
//# sourceMappingURL=search.mjs.map
